import { render, staticRenderFns } from "./FBadge.vue?vue&type=template&id=fa04c46c&"
import script from "./FBadge.vue?vue&type=script&lang=js&"
export * from "./FBadge.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports